module.exports = __webpack_public_path__ + "img/je.e0932aed.svg";